import React, { Component } from 'react'
import ParkingDashboard from "./parkingInfo"
import ParkingStatus from "./parkingStatus"

//redux
import { connect } from "react-redux";

class index extends Component {
    render() {
        return (
            <div>
                {this.props.user.role === "admin" ? <ParkingDashboard /> : <ParkingStatus />}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    user: state.user
})


export default connect(mapStateToProps)(index);
